import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import section_img_2 from "../../../Assets/section_img_2.jpg";
import section_img_3 from "../../../Assets/section_img_3.jpg";
import section_img_4 from "../../../Assets/section_img_4.jpg";



export default function BgSlider() {
  const slides = [section_img_2, section_img_3, section_img_4];

  const [index, setIndex] = useState(0);
  const sliderRef = useRef(null);
  const [isInView, setIsInView] = useState(true);

  // nxt img in 5sec
  useEffect(() => {
    if (!isInView) return; // pause when offscreen

    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [isInView, slides.length]);

  // Detect if slider is visible on screen
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsInView(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (sliderRef.current) observer.observe(sliderRef.current);
    return () => observer.disconnect();
  }, []);

  // Swipe
  const onDragEnd = (_, info) => {
    if (info.offset.x < -50) {
      setIndex((prev) => (prev + 1) % slides.length); 
    } else if (info.offset.x > 50) {
      setIndex((prev) => (prev - 1 + slides.length) % slides.length); 
    }
  };

  return (
    <div className="bg-slider" ref={sliderRef} style={{height:"100%"}}>
      {/* SLIDES */}
      {slides.map((img, i) => {
        const isActive = i === index;
        return (
          <motion.div
            key={i}
            className="slide"
            style={{
              backgroundImage: `
                linear-gradient(
                  to right,
                  rgba(22, 101, 52, 0.95) 0%,
                  rgba(22, 101, 52, 0.85) 40%,
                  rgba(22, 101, 52, 0.3) 100%
                ),
                url(${img})
              `,
              height: "100%",
              width: "100%",
              position: "absolute",
              objectFit: "cover",
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
            animate={isActive ? "active" : "inactive"}
            variants={{
              active: {
                opacity: 1,
                scale: 1.2,
                filter: "blur(0px)",
                transition: {
                  duration: 1.2,
                  ease: "easeInOut",
                },
              },
              inactive: {
                opacity: 0,
                scale: 1,
                filter: "blur(5px)",
                transition: {
                  duration: 1.2,
                },
              },
            }}
            drag="x"
            dragElastic={0.2}
            onDragEnd={onDragEnd}
          />
        );
      })}

      {/* DOTS */}
      <div className="dots">
        {slides.map((_, i) => (
          <div
            key={i}
            className={`dot ${i === index ? "active" : ""}`}
            onClick={() => setIndex(i)}
          ></div>
        ))}
      </div>
    </div>
  );
}
